import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_SOCIAL_LINKS } from '../../../shared/constants/data';

const SocialInfo = ({ className = '', links = DEFAULT_SOCIAL_LINKS }) => {
    const containerClassName = ['cm_socail_share', className].filter(Boolean).join(' ').trim();

    return (
        <div className={containerClassName}>
            {links.map(({ href, iconClass, label }) => (
                <a
                    key={href}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                >
                    <i className={iconClass}></i>
                </a>
            ))}
        </div>
    );
};

SocialInfo.propTypes = {
    className: PropTypes.string,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string.isRequired,
            iconClass: PropTypes.string.isRequired,
            label: PropTypes.string
        })
    )
};

export default SocialInfo;
export { DEFAULT_SOCIAL_LINKS };

